import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'Descarga e Identifica',
  desc: 'Descarga el material inmediatamente e identifica tu nivel de resistencia actual con los tests incluidos.'
}, {
  num: '02',
  title: 'Reseteo de 48 Horas',
  desc: 'Ejecuta el Protocolo de Reseteo de 48 horas para vaciar tus depósitos de azúcar estancados.'
}, {
  num: '03',
  title: 'Sincronización Diaria',
  desc: 'Aplica la Sincronización de Pulso en tus comidas diarias para mantener los resultados de por vida.'
}];
export function HowItWorks() {
  return <section className="py-24 px-4 bg-navy-900 relative" data-id="element-123">
      <div className="max-w-5xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-126">Cómo Funciona</h2>
          <p className="text-xl text-gray-400" data-id="element-127">
            Un proceso de 3 pasos diseñado para la simplicidad.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-128">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-navy-700 z-0" data-id="element-129"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-130">
              <div className="w-24 h-24 bg-navy-800 rounded-full border-4 border-brand-orange flex items-center justify-center text-3xl font-black text-white mb-6 shadow-[0_0_30px_rgba(232,130,12,0.2)]" data-id="element-131">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-132">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-133">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}